const displayName = (wrapperName, Component) =>
	`${wrapperName}(${Component.displayName || Component.name || "Unknown"})`;

export default displayName;
